import { format } from 'date-fns';
import { convertDateToTimeZone } from './convertDateToTimeZone';

/**
 * Formats a date in correct timezone.
 * @param date
 */
export function formatDate(date: Date | string, formatString: string): string {
	const timezoneDate = convertDateToTimeZone(date);
	return format(timezoneDate, formatString);
}
